import React, { useState, useEffect } from "react";
import "./Chat.css";
import ChatCard from "./ChatCard";
import ChatCardTwo from "./ChatCardTwo";
import { useParams } from "react-router-dom";
import { storage, auth, db } from "./firebase";
import firebase from "firebase";

function Chat() {
  const { booId } = useParams();
  const [customer, setCustomerData] = useState("");
  const [serviceOrder, setServiceOrder] = useState([]);
  const [getTas, setGetTas] = useState("");
  const [getHours, setGetHours] = useState([]);
  const [message, setMessage] = useState("");
  const [chats, setChat] = useState([]);
  function GetUserUid() {
    const [uid, setUid] = useState(null);
    useEffect(() => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          console.log("YESS", user);
          setUid(user.uid);
        }
      });
    }, []);
    return uid;
  }
  const uid = GetUserUid();

  function GetCurrentUser() {
    const [user, setUser] = useState(null);
    const [roomDetails, setRoomDetails] = useState([]);

    useEffect(() => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          db.collection("customers")
          .doc(user.uid)
          .get();
        } else {
          setUser(null);
        }
      });
    }, []);
    return user;
  }
  const user = GetCurrentUser();
  useEffect(() => {
    if (uid) {
      db.collection("customers")
        .doc(uid)
        .onSnapshot((snapshot) => setCustomerData(snapshot.data()));
    }
  });
  useEffect(() => {
    if (uid) {
      db.collection("customers")
        .doc(uid)
        .collection("serviceOrders")
        .doc(booId)
        .onSnapshot((snapshot) => setServiceOrder(snapshot.data()));
    }
  }, [uid]);
  useEffect(() => {
    if (serviceOrder?.tasId) {
      db.collection("ServiceProviders")
        .doc(serviceOrder?.tasId)
        .collection("ServiceRequests")
        .doc(serviceOrder?.requestId)
        .onSnapshot((snapshot) => setGetHours(snapshot.data()));
    }
  }, [serviceOrder?.tasId]);
  useEffect(() => {
    if (serviceOrder?.tasId) {
      db.collection("ServiceProviders")
        .doc(serviceOrder?.tasId)
        .onSnapshot((snapshot) => setGetTas(snapshot.data()));
    }
  });
  useEffect(() => {
    db.collection("chat").onSnapshot((snapshot) =>
      setChat(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          tasId: doc.data().tasId,
          customerId: doc.data().customerId,
          message: doc.data().message,
        }))
      )
    );
  }, []);
  useEffect(() => {
    db.collection("chat")
    .orderBy("timestamp", "asc")
    .onSnapshot((snapshot) =>
      setChat(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          tasId: doc.data().tasId,
          customerId: doc.data().customerId,
          message: doc.data().message,
          timestamp: doc.data().timestamp,
        }))
      )
    );
  }, []);
  const sendMessage = (e) => {
    e.preventDefault();
    console.log("yess");
   if (uid) {
      db.collection("chat").add({
        customerId: uid,
        tasId: serviceOrder?.tasId,
        message: message,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),

      }).then(() => {
        window.alert("SUCCESS");
      });
   }
    setMessage("");
  };
 
  return (
    <div className="App">
      <div className="wrapper">
        <div className="content">
          <div className="header">
            <div className="img">
              <img src="" alt="" />
            </div>
            <div className="right">
              <div className="status" style={{marginLeft: '-90px'}}>Active Now</div>
            </div>
          </div>
          <div className="main">
            {chats?.map(({ id, tasId, customerId, message }) => (
              <ChatCard
                id={id}
                tasId={tasId}
                customerId={customerId}
                message={message}
              />
            ))}
            <div style={{marginTop: '-100px'}}>
            <ChatCardTwo />
              </div>
          </div>
          <div className="bottom">
            <div className="btm">
              <div className="input">
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  id="input"
                  placeholder="Enter your message"
                />
              </div>
              <div className="btn">
                <button onClick={sendMessage}>
                  <i className="fas fa-paper-plane"></i>Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Chat;
